import { apiRequest } from "../auth/api-request";
import { ApiResponse } from "../dtos/api-respone.model";
import { Contact } from "../dtos/contact.model";
import { UserCompany } from "../dtos/user.model";
import { EntityService, IGetAllParams } from "./entity-service";

export class CompanyContactService extends EntityService<Contact> {
  baseUrl: string;
  constructor(id: number) {
    super();
    this.baseUrl = `companies/${id}/contacts`;
  }

  getAll(queries: IGetAllParams) {
    return apiRequest
      .get<
        ApiResponse<Contact[]>
      >(`${this.baseUrl}`, { params: { ...queries } })
      .then((o) => {
        return {
          ...o.data,
          data: o.data.data.map((user) => new Contact(user)),
        };
      });
  }

  getOne(contactId: number, queries?: IGetAllParams) {
    return apiRequest
      .get<ApiResponse<Contact>>(`${this.baseUrl}/${contactId}`, {
        params: { ...queries },
      })
      .then((o) => new Contact(o.data.data));
  }

  update(contactId: number, dto: Contact) {
    return apiRequest
      .put<
        ApiResponse<Contact>
      >(`${this.baseUrl}/${contactId}`, { ...new Contact(dto) })
      .then((o) => new Contact(o.data.data));
  }

  delete(contactId: number) {
    return apiRequest.delete(`${this.baseUrl}/${contactId}`);
  }

  create(dto: { email: string; phone: string }) {
    return apiRequest
      .post<ApiResponse<UserCompany>>(`${this.baseUrl}`, dto)
      .then((o) => {
        const id = o.data.data.userId;
        return this.getOne(id);
      });
  }
}
